import React from "react";
import { gettext } from "web/script/modules/django-i18n";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import styles from "./styles.css";

export default function AppStoreDetails({}): JSX.Element {
    return (
        <div className={styles.appStoreDetails}>
            <p>{gettext("app_landing.rating.number")}</p>
            <div className={styles.stars}>
                <SVGIcon name="stars" />
            </div>
            <p className={styles.rating}>{gettext("app_landing.rating.label")}</p>
        </div>
    );
}
